import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL_DOCS } from "@/components/torq/legalContent";

export default function LegalPage({ doc }) {
  const d = LEGAL_DOCS[doc];
  if (!d) return null;
  return (
    <main className="min-h-screen bg-[#161614] text-[#f0eee4] font-body antialiased" data-testid={`legal-${doc}`}>
      <div className="max-w-4xl mx-auto px-6 py-10 lg:py-16">
        <div className="flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-back"
            className="font-mono text-[11px] tracking-[0.25em] text-[#a3a39f] hover:text-[#f0eee4] transition-colors inline-flex items-center gap-2"
          >
            <ArrowLeft size={14} /> BACK
          </Link>
          <img src="/logo-long.png" alt="TORQ Circuit" className="h-6 w-auto" />
        </div>

        <p className="mt-12 font-mono text-[10px] tracking-[0.35em] text-[#6e6e6a]">{d.overline}</p>
        <h1 className="mt-3 font-display font-extrabold uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.9]" data-testid="legal-title">
          {d.title}
        </h1>
        <p className="mt-4 font-mono text-[10px] tracking-[0.2em] text-[#6e6e6a] leading-relaxed" data-testid="legal-meta">
          {d.meta}
        </p>
        {d.intro.map((p, i) => (
          <p key={i} className="mt-4 text-sm text-[#a3a39f] leading-relaxed">{p}</p>
        ))}

        <div className="mt-12 border-t border-[#2e2e2a]" data-testid="legal-sections">
          {d.sections.map((s, i) => (
            <section key={i} className="py-8 border-b border-[#2e2e2a]" data-testid={`legal-section-${i + 1}`}>
              <h2 className="font-display font-bold uppercase text-base md:text-lg flex gap-4">
                <span className="font-mono text-[11px] tracking-[0.2em] text-[#6e6e6a] mt-0.5 shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                {s.h}
              </h2>
              <div className="mt-4 space-y-3 md:pl-10">
                {s.paras?.map((p, j) => (
                  <p key={j} className="text-sm text-[#a3a39f] leading-relaxed">{p}</p>
                ))}
                {s.bullets && (
                  <ul className="space-y-2 font-mono text-[12px] tracking-[0.03em] text-[#a3a39f] leading-relaxed">
                    {s.bullets.map((b, j) => (
                      <li key={j}>— {b}</li>
                    ))}
                  </ul>
                )}
              </div>
            </section>
          ))}
        </div>

        {d.outro?.map((p, i) => (
          <p key={i} className="mt-6 font-mono text-[11px] tracking-[0.08em] text-[#6e6e6a] leading-relaxed">{p}</p>
        ))}

        <p className="mt-10 font-mono text-[11px] tracking-[0.15em] text-[#a3a39f] border border-[#2e2e2a] px-5 py-4" data-testid="legal-contact">
          QUESTIONS? WRITE TO{" "}
          <a href="mailto:info@torqcircuit.com" className="underline underline-offset-4 hover:text-[#f0eee4] transition-colors">
            INFO@TORQCIRCUIT.COM
          </a>
        </p>
      </div>
    </main>
  );
}
